import axios from 'axios'
import base from '../../base'
import { SHOWNPS } from './mutation-types'
import resource from './resource'

export default {
  /** Responde o NPS, com dados ou com Não gostaria de participar */
  async submitNPS(_, payload) {
    const config = {
      method: 'POST',
      url: resource,
      baseURL: base,
      data: payload
    }

    const { data } = await axios(config)
    return data
  },

  /** Verifica se o usuario está apto para receber a pergunta */
  async fetchNPS({ commit }) {
    const config = {
      method: 'GET',
      url: resource,
      baseURL: base
    }

    const { data } = await axios(config)
    commit(SHOWNPS, data)
  }
}
